module.exports = __webpack_public_path__ + "static/media/you_are_done.7460cdc8.svg";